import { FieldType } from '@ngx-formly/material';

import {
  Component,
  ElementRef,
  HostListener,
  Input,
  Output,
  EventEmitter,
  ChangeDetectionStrategy,
} from '@angular/core';

import { SnSize } from '@lib/common/types';
import { ISnRadialSliderFormFieldConfig } from '@lib/form/radial-slider';

@Component({
  selector: 'sn-radial-slider',
  templateUrl: './radial-slider.component.html',
  styleUrls: ['./radial-slider.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SnRadialSliderComponent extends FieldType<ISnRadialSliderFormFieldConfig> {
  public isDragging: boolean = false;
  public isMoving: boolean = false;

  @Input()
  get angle(): number {
    return this._angle;
  }
  set angle(deg: number) {
    this._angle = deg || 0;
    const dot = this.elementRef.nativeElement.querySelector('.dot');
    const cameraIcon = this.elementRef.nativeElement.querySelector('.camera-icon');
    const cameraAngle = this.elementRef.nativeElement.querySelector('.camera-angle');
    dot.style.transform = `rotate(${deg}deg)`;
    cameraIcon.style.transform = `rotate(${deg}deg)`;
    if (this.showDegrees && cameraAngle) {
      cameraAngle.innerHTML = `${deg}&#176`;
    }
  }

  @Input() public fontSet: string = 'fs';
  @Input() public fontIcon: string = 'Icon_CameraUp';
  @Input() public color: string = '#fff';
  @Input() public size: SnSize = 'xl';
  @Input() public showDegrees: boolean = true;

  @Output()
  public readonly angleChange = new EventEmitter<number>();

  @Output()
  public readonly dragChange = new EventEmitter<boolean>();

  private _angle: number = 0;

  constructor(public elementRef: ElementRef) {
    super();
  }

  public onStartDrag(event: any): void {
    if (event.which === 1) {
      this.isDragging = true;
      this.dragChange.next(true);
    }
  }

  public onDotStart(event: any): void {
    if (event.which === 1) {
      this.isMoving = true;
      this.dragChange.next(this.isMoving);
    }
  }

  public onDotEnd(event: any): void {
    if (event.which === 1) {
      this.isMoving = false;
      this.dragChange.next(this.isMoving);
      this.angleChange.next(this.angle);
    }
  }

  @HostListener('document:mouseup', ['$event'])
  @HostListener('document:touchend', ['$event'])
  public onEndDrag(): void {
    this.isDragging = false;
  }

  @HostListener('window:mousemove', ['$event'])
  @HostListener('window:touchmove', ['$event'])
  public move($event: Touch | MouseEvent): void {
    if (this.isDragging) {
      const circle = this.elementRef.nativeElement.querySelector('.circle');
      const circleRect = circle.getBoundingClientRect();
      const rectX = parseFloat(circleRect.x) + window.scrollX;
      const rectY = parseFloat(circleRect.y) + window.scrollY;
      const centerX = circleRect.width / 2 + rectX;
      const centerY = circleRect.height / 2 + rectY;
      const posX = $event.pageX;
      const posY = $event.pageY;
      const deltaY = centerY - posY;
      const deltaX = centerX - posX;
      let angle = Math.atan2(deltaY, deltaX) * (180 / Math.PI);
      angle -= 90;
      if (angle < 0) {
        angle = 360 + angle;
      }
      angle = Math.round(angle);
      this.angle = angle;
      this.angleChange.next(this.angle);
    }
  }

  @HostListener('window:touchmove', ['$event'])
  public onTouch(event: TouchEvent): void {
    this.move(event.touches[0]);
  }

  @HostListener('window:mousemove', ['$event'])
  public onMove(event: MouseEvent): void {
    this.move(event);
  }
}
